import { createModule, from, makeAsset } from "../../utils";

export const onboarding = createModule("onboarding", {
  analytics: {
    title: makeAsset,
    text: makeAsset
  },
  buttons: from("back", "next", "done"),
  compareCharts: {
    title: makeAsset,
    text: makeAsset
  },
  gamePlans: {
    title: makeAsset,
    text: makeAsset
  },
  insights: {
    title: makeAsset,
    text: makeAsset,
    action: makeAsset
  },
  overview: {
    welcome: from("title", "text"),
    attention: from("title", "text"),
    progress: from("title", "text"),
    collaboration: from("title", "text"),
    impact: from("title", "text"),
    timeline: from("title", "text"),
    plusbtn: from("title", "text"),
    preferences: from("title", "text", "action"),
    navigation: from("title", "text", "action"),
    insights: from("title", "text", "action"),
    activateInsight: from("title", "text", "action"),
    analytics: from("title", "text", "action"),
    gamePlans: from("title", "text", "action"),
    conclusion: from("title", "text", "action")
  },
  relaunch: from("action")
});
